import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TourOutlineIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TourOutlineIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M20.5153 20.1504H5.46422C4.09987 20.1504 2.98975 19.1375 2.98975 17.8919V8.58582C2.98975 7.34024 4.09987 6.32728 5.46422 6.32728H7.8754C8.10803 6.32728 8.31562 6.43231 8.45402 6.59819C8.90062 7.0281 10.8672 8.80569 12.9947 8.80569C15.1639 8.80569 17.1407 6.9859 17.5544 6.58052C17.6923 6.42543 17.8931 6.32728 18.1159 6.32728H20.5153C21.8796 6.32728 22.9897 7.34024 22.9897 8.58582V17.8919C22.9897 19.1375 21.8796 20.1504 20.5153 20.1504ZM5.46422 7.83494C4.94008 7.83494 4.4974 8.17848 4.4974 8.58582V17.8919C4.4974 18.2992 4.94008 18.6428 5.46422 18.6428H20.5153C21.0394 18.6428 21.4821 18.2992 21.4821 17.8919V8.58582C21.4821 8.17161 21.0482 7.83494 20.5153 7.83494H18.4231C17.6114 8.5927 15.4848 10.3133 12.9947 10.3133C10.4902 10.3133 8.32642 8.53871 7.56719 7.83494H5.46422Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.1159 7.83494H7.8754C7.45922 7.83494 7.12157 7.49729 7.12157 7.08111C7.12157 6.87401 7.20647 6.67279 7.35616 6.53047C7.79688 6.08779 10.1712 3.84888 12.9947 3.84888C15.7906 3.84888 18.1816 6.08091 18.6327 6.52851C18.775 6.66984 18.8697 6.87597 18.8697 7.07719V7.08112C18.8697 7.4973 18.532 7.83494 18.1159 7.83494ZM10.0426 6.32728H15.9525C15.1334 5.81786 14.09 5.35653 12.9946 5.35653C11.9037 5.35653 10.8593 5.81983 10.0426 6.32728Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default TourOutlineIcon;
